export const constants = ({
  Environment: {
    DEV: 0,
    INT: 1,
    PPE: 2,
    LOCAL: 3
  },
  Course_Title_Max_Length: 55,
  Course_Sub_Title_Max_Length: 30,
  Lesson_Title_Max_Length: 73,
  Element_Title_Step_Max_Length: 73,
  Leaps_Title_Max_Length: 1024,
  Assessment_RD_Element_Title_Step_Max_Length: 256,
  Master_Topic_Title_Max_Length: 50,
  Group_Course_Display_Title_Max_Length: 55,
  Group_Course_Display_Sub_Title_Max_Length: 30,
  Unrelease_Lesson_Msg_Max_Length: 25,
  Screen_Loading_AuthorName: 64,
  Screen_Loading_Quote: 256,
  LOGIN_COOKIE_KEY: 'LOGIN_MENTORA_ADMIN',
  LOGIN_USER_COOKIE: 'MENTORA_USER',
  No_Internet_Connection_Msg: 'Please check your internet connection and try again.',
  New_Password_Policy_Intro_Msg: 'Password must contain at least 10 characters in length, should contain at least 1 each of the following - lower case letters (a-z) | upper case letters (A-Z) | numbers (i.e. 0-9) | special characters.',
  Login_Tooltip: 'Participants who logged in',
  Current_Build_Version: '2.0.64',
  Engaged_Tooltip: 'Participants with Progress > 0%',
  Completed_Tooltip: 'Participants with 100% Progress',
  ReflectionRatingFiveText: 'Completely',
  ReflectionRatingFourText: 'Mostly though not completely',
  ReflectionRatingThreeText: 'Moderately',
  ReflectionRatingSecondText: 'In a limited way',
  ReflectionRatingFirstText: 'Not at all',
  M365_Course_Name: 'Mentora 365',
  Empty_Guid: '00000000-0000-0000-0000-000000000000',
  Default_Assessment_Module_Id_Guid: '11111111-1111-1111-1111-111111111111',
  Default_Meeting_Mentor_Course: '22222222-2222-2222-2222-222222222222',
  Is_Bonus_Content_True_Tooltip_Text: ' Bonus ',
  Is_Bonus_Content_False_Tooltip_Text: ' Normal ',
  Is_Optional_True_Tooltip_Text: ' Optional ',
  Is_Optional_False_Tooltip_Text: ' Compulsory ',
  Is_Unlocked_False_Tooltip_Text: ' Locked ',
  Is_Unlocked_True_Tooltip_Text: ' Unlocked ',
  Include_In_Progress_False_Tooltip_Text: ' Not included in progress ',
  Include_In_Progress_True_Tooltip_Text: ' Include in progress ',
  Mentora_Dev_Auth0_Client_Id: '68hPsgRm8H1KiQw88XGrBiJJflMYf0uo',
  Mentora_Stage_Auth0_Client_Id: '8aI1B43gSWY6CqbyHo87ViALnYGetLod',
  Mentora_Prod_Auth0_Client_Id: 'LoEyQdxprxJdWGWa1sFNlo90o4dFs1ta',
  Mentora_Dev_Auth0_Realm_Or_Connection: 'Mentora-connection',
  Mentora_Stage_Auth0_Realm_Or_Connection: 'Mentora-Stage-connection',
  Mentora_Prod_Auth0_Realm_Or_Connection: 'Mentora-Prod-connection',
  Change_Password_Error_Profile: 'change_password',
  Change_Password_Button_Text: 'Update Now',
  Sign_Out_Button_Text: 'Sign Out',
  Change_Password_Alert_Msg: 'Your password has expired and must be changed.',
  Logged_Out_From_Another_Platform_Error_Msg: 'Your password was changed using another platform. Please re-login using the new password to get going.',
  userPerPage: 25,
  TLQ_MCQ_Red_Option: 'I didn\'t use it',
  TLQ_MCQ_Yellow_Option: 'Used it but good have gone better',
  TLQ_MCQ_Green_Option: 'I used it and it went well',
  Certificate_Title_Max_Length: 150,
  To_Email_Tooltip: 'These can be also a comma-separated value.',
  Certificate_Title_Tooltip: '"$$" as a separator to add multiple titles like "TITLE ABC $$ TITLE XYZ"',
  PersonalizationRule: {
    Rule1: 'Quant Score Is In Range',
    Rule2: 'Is Specific Option NOT Selected',
    Rule3: 'Is Specific Option Selected',
    Rule4: 'Option Is In Range',
    Rule5: 'Is Correct',
    Rule6: 'Is Incorrect',
    Rule7: 'TLQ Percentage Is In Range',
    Rule8: 'Path is Exactly',
    Rule9: 'Path Has',
    Rule10: 'Is Not a Specific Outcome',
    Rule11: 'Is a Specific Outcome',
    Rule12: 'Is Lower Than a Specific Outcome',
    Rule13: 'Is Higher Than a Specific Outcome',
    Rule14: 'Is Completed'
  },
  ReflectionTLQOptionEnum: {
    None: 0,
    DidNotUse: 1,
    SomeWhatEffective: 2,
    VeryEffective: 3
  },
  PersonalizationAction: {
    Action1: 'Remove Elements',
    Action2: 'Send Email',
    Action3: 'Show Alert',
    Action4: 'Send Notification',
    Action5: 'Add Elements',
    Action6: 'Add To Recommendations',
    Action7: 'Remove From Recommendations'
  },
  Transition: {
    No_Transition: 0,
    Modal_Bottom_To_Top: 1
  },
  BackgroundColor: {
    Default_Background: 0,
    Light_Background: 1,
    Dark_Background: 2
  },
  ALGOutcome: {
    Outcome1: 0,
    Outcome2: 1,
    Outcome3: 2,
    Outcome4: 3
  },
  MsTeamsNotificationTypeEnum: {
    Preparation: 0,
    Reflection: 1
  },
  BlacklistedNames: {
    cohorts: ['internal']
  },
  ClientPlatform: {
    iPhone: 0,
    Android: 1,
    Web: 2,
    Admin: 3
  },
  ReportingTaskFrequency: {
    None: -1,
    Immediate: 0,
    Daily: 1,
    Weekly: 7,
    Monthly: 30
  },
  ReportTaskState: {
    NotStarted: 0,
    Running: 1,
    Scheduled: 2,
    Error: 3,
    Completed: 4
  },
  RecommendActionOperatorEnum: {
    None: -1,
    LessThan: 0,
    LessThanEqual: 1,
    GreaterThan: 2,
    GreaterThanEqual: 3,
    EqualTo: 4
  },
  UserAccountType: {
    User: 0,
    Group_Admin: 1,
    Admin: 2,
    Coach: 3
  },
  DescVideoType: {
    Normal: 0,
    Teachback: 1
  },
  MilestoneInfoType: {
    Cumulative_Progress: 101,
    Specific_Element_Completion: 202
  },
  MilestoneActionType: {
    Allow_Specified_Courses: 101,
    Allow_All_Electives: 201
  },
  MissionQuestionType: {
    Opening: 0,
    Closing: 1
  },
  NotificationStatus: {
    Queued: 0,
    Sent: 1
  },
  ResponseType: {
    Video: 0,
    Audio: 1,
    Text: 2
  },
  CourseType: {
    Normal: 0,
    M365: 1,
    RecommendationAssessment: 2
  },
  DeleteToolkitAndImage: {
    None: -1,
    DeleteToolkit: 0,
    DeleteImage: 1,
    DeleteToolkitAndImage: 2
  },
  MasterTopicType: {
    Normal: 0,
    MentoraMeetingAction: 1
  },
  ModuleType: {
    Normal: 0,
    Personalization: 1,
    Assessment: 2
  },
  OptionColorCode: {
    Red: 0,
    Yellow: 1,
    Green: 2
  },
  LessonNumberingType: {
    Default: 0,
    Custom: 1,
    Hide: 2
  },
  UserGender: {
    Male: 0,
    Female: 1
  },
  GroupName: {
    None: 0,
    TCS: 1,
    Morgan_Stanley: 2,
    Deloitte: 3
  },
  SessionTimeoutUnit: {
    Minutes: 0,
    Hours: 1,
    Days: 2
  },
  CourseSearchBarEnum: {
    AssessmentJourney: 0,
    Course: 1
  },
  SubMenuOptionsEnum: {
    NotSet: 0,
    Courses: 1,
    ManageContent: 2,
    Challenges: 3,
    FileUploader: 4,
    Participants: 5,
    Groups: 6,
    Cohorts: 7,
    UserResponses: 8,
    ChallengeReport: 9,
    UserProgress: 10,
    McqReport: 11,
    DeepDive: 12,
    Discussions: 13,
    EmailUsers: 14,
    ProgressionEmail: 15,
    ViewSentEmails: 16,
    ManageAdmins: 17,
    Notifications: 18, // notify
    EditProfile: 19,
    ResetPassword: 20,
    Logout: 21,
    AdminActivity: 22,
    LessonwiseProgress: 23,
    SendGrid: 24,
    SSOConfiguration: 25,
    Mentora365: 26,
    M365Report: 27,
    MissionReport: 28,
    AdaptiveGameReport: 29,
    VATConsumptionReport: 30,
    MilestoneReport: 31,
    Utilities: 32,
    MasterTopic: 33,
    Moments: 34,
    Certificate: 35,
    LearningLevel: 36,
    ScreenLoading: 37,
    Assessment: 38,
    AssessmentJourney: 39,
    PersonalizationRule: 40,
    ElementwiseProgress: 41,
    LEAPSChallenges: 42,
    LEAPSMeditation: 43,
    LEAPSAction: 44,
    LEAPSCategory: 45,
    LEAPSEnergy: 46,
    LEAPSAffirmation: 47,
    MeetingMentor: 48,
    AssessmentSubType: 49,
    LEAPSIntention: 50,
    MSNotif: 51,
    DashboardEmail: 52,
    LPReport: 53
  },
  NewReportType: {
    Participant_Progress_v2: 101,
    New_Report_RemainingProgress_v2: 102,
    Client_Dashboard_V2: 103,
    Assessment: 104,
    Recommendation_Summary: 105,
    MP_Element_MOT_Teachback: 106,
    MP_Element_ALG: 107,
    MP_Element_Mission: 108,
    MP_Element_Consolidated: 109,
    MCQ_Report_V2: 110,
    Reflection_Report_V2: 111,
    Participant_Progress_v1: 112,
    Coursewise_Element_View_Progress_Report_V2: 113,
    Participant_View_Progress_Report: 114
  },
  UserSubsetTypeEnum: {
    FacilitatorOnly: 1,
    ParticipantsOnly: 2,
    Both: 3
  },
  MenuOptionsEnum: {
    Dashboard: 1,
    Content: 2,
    Users: 3,
    Reports: 4,
    Emails: 5,
    Settings: 6,
    Notifications: 7,
    NewReport: 8,
    LEAPS: 9
  },
  Question_Type: {
    Single_Answer: 0,
    Multiple_Answers: 1
  },
  Video_Quality: {
    Q_360: 0,
    Q_Auto: 1,
    Q_720: 2
  },
  FileType: {
    NotAllowed: -1,
    PDF: 0,
    Image: 1
  },
  ChallengeFeedbackType: {
    Regular_Challenge: 0,
    Self_Challenge: 1
  },
  ReportSubOptionEnum: {
    None: -1,
    UserProgress: 0,
    Discussions: 1,
    Challenges_Participant_Progress: 2,
    Challenges_Progress_Summary: 3,
    Challenges_Skill_Assessment: 4,
    Challenges_Participant_Progress_Quant: 5,
    MCQ: 6,
    DeepDive_Participant: 7,
    DeepDive_Views: 8,
    Lesson_Wise_Progress: 9
  },
  EmailTemplateType: {
    Normal: 0,
    Progression: 1,
    Dashboard_Email: 2
  },
  AssessmentType: {
    Personalization: 100,
    PrePost: 200,
    StandAlone: 300
  },
  AdminActivityType: {
    Login: 0,
    Manage_Participant: 1,
    Manage_Course: 2,
    Manage_GroupCourse: 3,
    Manage_GroupCourseCohort: 4,
    Manage_Steps: 5,
    Manage_Lessons: 6,
    Manage_Challenges: 7,
    Manage_MCQ: 8,
    Manage_Emails: 9,
    Manage_Reports: 10,
    Manage_UserData: 11,
    Manage_Dashboard: 12,
    Manage_Files: 13,
    Manage_MyProfile: 14,
    Generic: 15,
    Logout: 16,
    Manage_UserActivity: 17,
    Manage_AdminActivity: 18,
    Manage_Group: 19,
    Manage_Technique: 20,
    Manage_Topic: 21,
    Manage_Notification: 22,
    Update_User_Progress: 38,
    User_Request: 39,
    List_Favorites: 40,
    Toggle_Favorite: 41,
    Manage_Master_Topic: 27,
    Manager_Learning_Level: 28,
    Manage_Assessment: 29,
    Assessment_Journey: 30
  },
  AdminActionType: {
    Default: -1,
    Get: 0,
    Add: 1,
    Update: 2,
    Delete: 3,
    ListAll: 4,
    FilteredList: 5,
    ButtonClick: 6,
    LoadScreen: 7,
    NavigationClick: 8,
    UpdateDashboardParams: 9,
    Search: 10,
    SendMail: 11,
    SendProgressionMail: 12
  },
  AuthenticationType: {
    SP_Initiated: 0,
    IDP_Initiated: 1
  }
})
/* Course Master Obj - Use the below object structure while POSTing/PUTting the data to API
{
  CourseMasterId: newCourseMaster.CourseMasterId,
  CourseTitle: newCourseMaster.CourseTitle,
  SubTitle: courseMasterObj.SubTitle,
  IsEnabled: courseMasterObj.IsEnabled,
  Version: courseMasterObj.Version,
  ToolkitFileUrl: courseMasterObj.ToolkitFileUrl
};
*/



// WEBPACK FOOTER //
// ./src/utils/constants.js